<!-- 产品与服务页面 -->
<template>
  <div class="product-page">
    <Navbar />

    <!-- 页头 -->
    <section class="product-hero">
      <div class="product-hero-overlay"></div>
      <div class="product-hero-particles">
        <span v-for="n in 8" :key="n" class="particle" :style="{ '--i': n }"></span>
      </div>
      <div class="container">
        <div class="product-hero-content">
          <span class="section-tag">SERVICES</span>
          <h1 class="product-hero-title">产品与服务</h1>
          <p class="product-hero-desc">三大核心修复服务 · 德国PDR技术 · 原厂漆守护者</p>
          <div class="hero-divider">
            <span class="line"></span>
            <span class="diamond"></span>
            <span class="line"></span>
          </div>
          <div class="hero-stats-row">
            <div class="hero-stat">
              <span class="stat-num">{{ statCases }}</span><span class="stat-suffix">+</span>
              <span class="stat-label">案例</span>
            </div>
            <div class="hero-stat-divider"></div>
            <div class="hero-stat">
              <span class="stat-num">{{ statSatisfaction }}</span><span class="stat-suffix">%</span>
              <span class="stat-label">满意度</span>
            </div>
            <div class="hero-stat-divider"></div>
            <div class="hero-stat">
              <span class="stat-num">{{ statYears }}</span><span class="stat-suffix">年</span>
              <span class="stat-label">专业经验</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 三大服务 -->
    <section class="services-section" id="services">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">WHAT WE DO</span>
          <h2 class="section-title">三大核心修复服务</h2>
          <p class="section-subtitle">专业 · 高效 · 原厂漆守护</p>
        </div>

        <div class="services-grid">
          <!-- 服务1 -->
          <div class="service-card" :class="{ 'featured': true }">
            <div class="service-card-icon-wrap">
              <img src="@/components/images/科曼驰项目-凹陷修复.png" alt="凹陷修复" class="service-card-icon" />
            </div>
            <div class="service-card-body">
              <div class="service-card-divider">
                <span class="line"></span><span class="dot"></span><span class="line"></span>
              </div>
              <p class="service-card-desc">专业PDR工具从内部精准顶推，恢复车身弧线。冰雹坑、车门凹痕、停车磕碰，不动钣金不伤漆。</p>
              <ul class="service-card-features">
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>冰雹坑修复</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>车门凹痕</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>停车磕碰</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>保留原厂漆</li>
              </ul>
              <router-link to="/contact#contact-form" class="service-card-cta">预约咨询</router-link>
            </div>
          </div>

          <!-- 服务2 -->
          <div class="service-card">
            <div class="service-card-icon-wrap">
              <img src="@/components/images/科曼驰项目-玻璃修复.png" alt="玻璃修复" class="service-card-icon" />
            </div>
            <div class="service-card-body">
              <div class="service-card-divider">
                <span class="line"></span><span class="dot"></span><span class="line"></span>
              </div>
              <p class="service-card-desc">牛眼裂纹、星状破损，进口树脂高压注胶，紫外线固化后强度接近原厂，避免高额换玻璃费用。</p>
              <ul class="service-card-features">
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>牛眼裂纹</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>星状破损</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>进口树脂</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>UV固化</li>
              </ul>
              <router-link to="/contact#contact-form" class="service-card-cta">预约咨询</router-link>
            </div>
          </div>

          <!-- 服务3 -->
          <div class="service-card">
            <div class="service-card-icon-wrap">
              <img src="@/components/images/科曼驰项目-局部点漆.png" alt="局部点漆" class="service-card-icon" />
            </div>
            <div class="service-card-body">
              <div class="service-card-divider">
                <span class="line"></span><span class="dot"></span><span class="line"></span>
              </div>
              <p class="service-card-desc">小面积划痕、掉漆精准点补，电脑调色匹配原车漆，修复后几乎无色差，经济快捷。</p>
              <ul class="service-card-features">
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>精准点补</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>电脑调色</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>无色差</li>
                <li><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>经济快捷</li>
              </ul>
              <router-link to="/contact#contact-form" class="service-card-cta">预约咨询</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品展示 -->
    <section class="product-showcase" v-if="productList.length">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">PRODUCT GALLERY</span>
          <h2 class="section-title">案例展示</h2>
          <p class="section-subtitle">真实案例 · 见证品质</p>
        </div>
        <div class="showcase-grid">
          <div
            v-for="(item, i) in productList"
            :key="item._id"
            class="showcase-item"
            :style="{ animationDelay: i * 0.1 + 's' }"
            @click="openDetail(i)"
          >
            <div class="showcase-img-wrap">
              <div
                class="showcase-img"
                :style="{ backgroundImage: `url(${item.cover})` }"
              ></div>
              <div class="showcase-overlay">
                <h4 class="showcase-title">{{ item.title }}</h4>
                <p class="showcase-desc">{{ item.introduction }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 案例详情弹窗 -->
    <div class="detail-overlay" :class="{ open: detailOpen }" @click.self="closeDetail">
      <button class="detail-close" @click="closeDetail">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <button class="detail-prev" @click.stop="prevCase" :disabled="detailIndex === 0">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
      </button>
      <div class="detail-container" @click.stop>
        <div class="detail-image-wrap">
          <img
            :src="`${currentCase?.cover}`"
            :alt="currentCase?.title"
            class="detail-image"
          />
          <div class="detail-image-badge">
            <span class="case-counter">{{ detailIndex + 1 }} / {{ productList.length }}</span>
          </div>
        </div>
        <div class="detail-info">
          <span class="section-tag">CASE STUDY</span>
          <h2 class="detail-title">{{ currentCase?.title }}</h2>
          <div class="detail-divider">
            <span class="line"></span>
            <span class="diamond"></span>
            <span class="line"></span>
          </div>
          <p class="detail-desc">{{ currentCase?.introduction }}</p>
          <p class="detail-body">{{ currentCase?.content }}</p>
          <div class="detail-meta" v-if="currentCase?.serviceType || currentCase?.carModel">
            <div class="meta-item" v-if="currentCase?.carModel">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2"><rect x="1" y="3" width="15" height="13" rx="2"/><polyline points="16 8 20 8 23 11 23 16 16 16 16 8"/></svg>
              <span>{{ currentCase.carModel }}</span>
            </div>
            <div class="meta-item" v-if="currentCase?.serviceType">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <span>{{ currentCase.serviceType }}</span>
            </div>
          </div>
          <div class="detail-actions">
            <button class="btn-back" @click="closeDetail">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>
              返回列表
            </button>
            <button
              class="btn-next"
              @click.stop="nextCase"
              :disabled="detailIndex === productList.length - 1"
            >
              下一案例
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </div>
        </div>
      </div>
      <button class="detail-next" @click.stop="nextCase" :disabled="detailIndex === productList.length - 1">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
      </button>
    </div>

    <!-- 工艺介绍 -->
    <section class="process-section">
      <div class="container">
        <div class="section-header">
          <span class="section-tag">OUR PROCESS</span>
          <h2 class="section-title">德国PDR工艺</h2>
          <p class="section-subtitle">无损修复 · 技术领先 · 效果持久</p>
        </div>
        <div class="process-steps">
          <div
            v-for="(step, i) in processSteps"
            :key="i"
            class="process-step"
            :style="{ animationDelay: i * 0.12 + 's' }"
          >
            <div class="step-number">{{ String(i + 1).padStart(2, '0') }}</div>
            <div class="step-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d4af37" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            </div>
            <h4 class="step-title">{{ step.title }}</h4>
            <p class="step-desc">{{ step.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="product-cta">
      <div class="container">
        <div class="cta-content">
          <span class="section-tag">GET IN TOUCH</span>
          <h2>选择科曼驰，守护您的爱车</h2>
          <p>科曼驰团队为您提供免费凹陷评估及修复方案</p>
          <div class="cta-actions">
            <a href="tel:159-3133-4385" class="btn-primary">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              致电咨询
            </a>
            <router-link to="/contact" class="btn-outline">了解更多</router-link>
          </div>
        </div>
      </div>
    </section>

    <el-backtop :visibility-height="200" />
  </div>
</template>

<script setup>
import { ref, onMounted, onActivated, onUnmounted, computed, watch } from 'vue'
import axios from 'axios'
import Navbar from '@/components/Navbar.vue'

const productList = ref([])
const detailOpen = ref(false)
const detailIndex = ref(0)

// 数字增长动画
const statCases = ref(0)
const statSatisfaction = ref(0)
const statYears = ref(0)

let statAnimTimer = null

function animateNumber(el, from, to, duration) {
  const start = performance.now()
  function update(now) {
    const elapsed = now - start
    const progress = Math.min(elapsed / duration, 1)
    // easeOutExpo
    const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress)
    el.value = Math.floor(from + (to - from) * ease)
    if (progress < 1) {
      statAnimTimer = requestAnimationFrame(update)
    }
  }
  statAnimTimer = requestAnimationFrame(update)
}

function triggerStatAnimation() {
  if (statAnimTimer) cancelAnimationFrame(statAnimTimer)
  const prevCases = statCases.value
  const prevSat = statSatisfaction.value
  const prevYears = statYears.value
  animateNumber(statCases, prevCases, 3000, 1800)
  animateNumber(statSatisfaction, prevSat, 99, 1800)
  animateNumber(statYears, prevYears, 8, 1200)
}

const processSteps = [
  { title: '检测评估', desc: '专业技师全面检测凹陷程度，制定精准修复方案' },
  { title: '内部顶推', desc: '使用专业PDR工具从内部精准顶推，恢复车身弧线' },
  { title: '细节处理', desc: '精细调整表面平整度，确保修复后无痕迹' },
  { title: '质检交付', desc: '严格质检，确认效果后交付，提供质保服务' },
]

const openDetail = (index) => {
  detailIndex.value = index
  detailOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeDetail = () => {
  detailOpen.value = false
  document.body.style.overflow = ''
}

const nextCase = () => {
  if (detailIndex.value < productList.value.length - 1) {
    detailIndex.value++
  }
}

const prevCase = () => {
  if (detailIndex.value > 0) {
    detailIndex.value--
  }
}

const handleKeydown = (e) => {
  if (!detailOpen.value) return
  if (e.key === 'ArrowLeft') prevCase()
  else if (e.key === 'ArrowRight') nextCase()
  else if (e.key === 'Escape') closeDetail()
}

onMounted(async () => {
  console.log('Product onMounted called')
  try {
    const res = await axios.get('/webapi/product/list')
    productList.value = res.data.data || []
  } catch (e) {
    console.error('获取产品数据失败:', e)
  }
  window.addEventListener('keydown', handleKeydown)
  triggerStatAnimation()
})

onActivated(() => {
  triggerStatAnimation()
})

const currentCase = computed(() => productList.value[detailIndex.value] || null)
onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown)
  // 页面切换时始终清理 overflow
  document.body.style.overflow = ''
})
</script>

<style scoped lang="scss">
// ===== 变量 =====
$gold: #d4af37;
$gold-light: #f0e4c8;
$dark: #1a1a1a;
$gray: #6b7280;
$light-gray: #f8f9fa;
$border: #e5e7eb;

// ===== 全局 =====
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

// ===== 公共样式 =====
.section-tag {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: $gold;
  display: block;
  margin-bottom: 12px;
}

.section-title {
  font-size: 36px;
  font-weight: 800;
  color: $dark;
  margin: 8px 0 12px;
}

.section-subtitle {
  font-size: 16px;
  color: $gray;
}

.section-header {
  text-align: center;
  margin-bottom: 56px;
}

.hero-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin: 28px 0;

  .line {
    width: 80px;
    height: 1px;
    background: linear-gradient(to right, transparent, $gold, transparent);
    opacity: 0.5;
  }

  .diamond {
    width: 6px;
    height: 6px;
    background: $gold;
    transform: rotate(45deg);
  }
}

.hero-stats-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin-top: 24px;

  .hero-stat {
    display: flex;
    align-items: baseline;
    gap: 2px;

    .stat-num {
      font-size: 32px;
      font-weight: 800;
      color: #fff;
      line-height: 1;
      font-variant-numeric: tabular-nums;
      animation: statFadeIn 0.5s ease both;
    }

    .stat-suffix {
      font-size: 16px;
      font-weight: 600;
      color: $gold;
    }

    .stat-label {
      display: block;
      font-size: 12px;
      color: rgba(255,255,255,0.5);
      margin-top: 4px;
      letter-spacing: 1px;
    }
  }

  .hero-stat-divider {
    width: 1px;
    height: 36px;
    background: rgba(255,255,255,0.15);
  }
}

// ===== 页头 =====
.product-hero {
  position: relative;
  min-height: 520px;
  background: linear-gradient(135deg, $dark 0%, #2a2a2a 100%);
  display: flex;
  align-items: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -20%;
    right: -5%;
    width: 700px;
    height: 700px;
    background: radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%);
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, $gold, transparent);
    opacity: 0.3;
  }
}

.product-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 100%);
}

.product-hero-particles {
  position: absolute;
  inset: 0;
  pointer-events: none;

  .particle {
    position: absolute;
    width: 4px;
    height: 4px;
    background: $gold;
    border-radius: 50%;
    opacity: 0;
    box-shadow: 0 0 8px $gold;
    animation: floatParticle 4s ease-in-out infinite;
    animation-delay: calc(var(--i) * 0.4s);
  }
}

@keyframes floatParticle {
  0%, 100% { transform: translateY(0) scale(1); opacity: 0.2; }
  50% { transform: translateY(-40px) scale(1.3); opacity: 0.6; }
}

@keyframes statFadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.product-hero-content {
  position: relative;
  z-index: 2;
  padding: 60px 0;
  text-align: center;

  .product-hero-title {
    font-size: 52px;
    font-weight: 800;
    color: #fff;
    letter-spacing: 2px;
    margin-bottom: 16px;
  }

  .product-hero-desc {
    font-size: 17px;
    color: rgba(255,255,255,0.6);
    letter-spacing: 1px;
  }
}

// ===== 服务卡片 =====
.services-section {
  padding: 80px 0;
  background: $light-gray;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  align-items: start;
}

.service-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid $border;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;

  &.featured {
    border-color: $gold;
    box-shadow: 0 8px 32px rgba(212,175,55,0.12);

    .service-card-badge { display: block; }
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 48px rgba(0,0,0,0.1);
  }

  .service-card-badge {
    display: none;
    position: absolute;
    top: -10px;
    right: 20px;
    padding: 4px 16px;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    background: $gold;
    border-radius: 20px;
    z-index: 2;
  }

  .service-card-icon-wrap {
    height: 260px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, $light-gray 0%, #fff 100%);
    padding: 20px;

    .service-card-icon {
      width: 200px;
      height: 200px;
      object-fit: contain;
      border-radius: 20px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.1);
      transition: transform 0.4s ease;
    }
  }

  &:hover .service-card-icon {
    transform: scale(1.08);
  }

  .service-card-body {
    padding: 28px 24px 32px;
  }

  .service-card-title {
    font-size: 20px;
    font-weight: 700;
    color: $dark;
    margin-bottom: 12px;
  }

  .service-card-divider {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;

    .line {
      flex: 1;
      height: 1px;
      background: $border;
    }

    .dot {
      width: 5px;
      height: 5px;
      background: $gold;
      border-radius: 50%;
      flex-shrink: 0;
    }
  }

  .service-card-desc {
    font-size: 14px;
    line-height: 1.75;
    color: $gray;
    margin-bottom: 20px;
  }

  .service-card-features {
    list-style: none;
    padding: 0;
    margin: 0 0 24px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;

    li {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 13px;
      color: $dark;
      font-weight: 500;
    }
  }

  .service-card-cta {
    display: block;
    text-align: center;
    padding: 12px;
    font-size: 14px;
    font-weight: 600;
    color: $gold;
    border: 1px solid $gold;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      background: $gold;
      color: #fff;
    }
  }
}

// ===== 案例展示 =====
.product-showcase {
  padding: 80px 0;
  background: #fff;
}

.showcase-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.showcase-item {
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  opacity: 0;
  transform: translateY(20px);
  animation: cardSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;

  &:hover {
    .showcase-img { transform: scale(1.08); }
    .showcase-overlay { opacity: 1; }
  }

  .showcase-img-wrap {
    position: relative;
    height: 220px;
    overflow: hidden;
  }

  .showcase-img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .showcase-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 60%, transparent 100%);
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 16px;
    opacity: 0;
    transition: opacity 0.4s ease;

    .showcase-title {
      font-size: 14px;
      font-weight: 700;
      color: #fff;
      margin-bottom: 4px;
    }

    .showcase-desc {
      font-size: 12px;
      color: rgba(255,255,255,0.7);
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      line-height: 1.5;
    }
  }
}

@keyframes cardSlideUp {
  to { opacity: 1; transform: translateY(0); }
}

// ===== 工艺步骤 =====
.process-section {
  padding: 80px 0;
  background: $light-gray;
}

.process-steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  align-items: start;
}

.process-step {
  text-align: center;
  padding: 0 16px;
  position: relative;
  opacity: 0;
  transform: translateY(20px);
  animation: cardSlideUp 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;

  .step-number {
    font-size: 48px;
    font-weight: 900;
    color: rgba(212,175,55,0.12);
    line-height: 1;
    margin-bottom: 8px;
  }

  .step-line {
    display: none;
  }

  .step-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 16px;
    background: rgba(212,175,55,0.08);
    border: 1px solid rgba(212,175,55,0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .step-title {
    font-size: 17px;
    font-weight: 700;
    color: $dark;
    margin-bottom: 8px;
  }

  .step-desc {
    font-size: 13px;
    color: $gray;
    line-height: 1.7;
  }
}

// ===== CTA =====
.product-cta {
  padding: 80px 0;
  background: linear-gradient(135deg, $dark 0%, #2a2a2a 100%);
  text-align: center;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -30%;
    left: -10%;
    width: 500px;
    height: 500px;
    background: radial-gradient(circle, rgba(212,175,55,0.08) 0%, transparent 70%);
    border-radius: 50%;
  }

  .cta-content {
    position: relative;
    z-index: 2;

    .section-tag { margin-bottom: 16px; }

    h2 {
      font-size: 36px;
      font-weight: 800;
      color: #fff;
      margin-bottom: 12px;
    }

    p {
      font-size: 16px;
      color: rgba(255,255,255,0.5);
      margin-bottom: 36px;
    }
  }

  .cta-actions {
    display: flex;
    gap: 16px;
    justify-content: center;
  }
}

// ===== 案例详情弹窗 =====
.detail-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.88);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.35s ease;

  &.open {
    opacity: 1;
    pointer-events: auto;
  }
}

.detail-close {
  position: absolute;
  top: 24px;
  right: 24px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: rotate(90deg);
  }
}

.detail-prev,
.detail-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover:not(:disabled) {
    background: rgba(212, 175, 55, 0.3);
    border-color: $gold;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

.detail-prev { left: 24px; }
.detail-next { right: 24px; }

.detail-container {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 40px;
  max-width: 1000px;
  width: 90%;
  max-height: 85vh;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.4);
  animation: detailZoomIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes detailZoomIn {
  from {
    transform: scale(0.9) translateY(30px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.detail-image-wrap {
  position: relative;
  height: 100%;
  min-height: 400px;
  background: $light-gray;
  overflow: hidden;

  .detail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  &:hover .detail-image {
    transform: scale(1.03);
  }

  .detail-image-badge {
    position: absolute;
    bottom: 16px;
    left: 16px;
    padding: 6px 14px;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
    border-radius: 20px;

    .case-counter {
      font-size: 13px;
      font-weight: 600;
      color: $gold;
      letter-spacing: 1px;
    }
  }
}

.detail-info {
  padding: 40px 36px;
  display: flex;
  flex-direction: column;
  gap: 0;
  overflow-y: auto;

  .section-tag { margin-bottom: 8px; }

  .detail-title {
    font-size: 26px;
    font-weight: 800;
    color: $dark;
    margin-bottom: 16px;
    line-height: 1.3;
  }

  .detail-divider {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;

    .line {
      flex: 1;
      height: 1px;
      background: linear-gradient(to right, transparent, $gold, transparent);
      opacity: 0.4;
    }

    .diamond {
      width: 5px;
      height: 5px;
      background: $gold;
      transform: rotate(45deg);
    }
  }

  .detail-desc {
    font-size: 15px;
    color: $gray;
    line-height: 1.8;
    margin-bottom: 12px;
  }

  .detail-body {
    font-size: 14px;
    color: $gray;
    line-height: 1.9;
    margin-bottom: 24px;
    white-space: pre-wrap;
  }

  .detail-meta {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 28px;
    padding-bottom: 24px;
    border-bottom: 1px solid $border;

    .meta-item {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 14px;
      background: rgba(212, 175, 55, 0.06);
      border: 1px solid rgba(212, 175, 55, 0.15);
      border-radius: 20px;
      font-size: 13px;
      font-weight: 500;
      color: $dark;
    }
  }

  .detail-actions {
    display: flex;
    gap: 12px;
    margin-top: auto;

    .btn-back {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 12px 24px;
      font-size: 14px;
      font-weight: 600;
      color: $dark;
      background: $light-gray;
      border: 1px solid $border;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;

      &:hover {
        background: #fff;
        border-color: $gold;
        color: $gold;
      }
    }

    .btn-next {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      padding: 12px 24px;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      background: $gold;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: all 0.3s ease;
      flex: 1;
      justify-content: center;

      &:hover:not(:disabled) {
        background: #c4a030;
        transform: translateY(-1px);
        box-shadow: 0 8px 20px rgba(212, 175, 55, 0.3);
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }
  }
}

// ===== 按钮 =====
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 36px;
  font-size: 15px;
  font-weight: 600;
  color: $dark;
  background: $gold;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.35s ease;

  &:hover {
    background: #c4a030;
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(212,175,55,0.3);
  }
}

.btn-outline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 36px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.35s ease;

  &:hover {
    background: rgba(255,255,255,0.08);
    border-color: rgba(255,255,255,0.7);
    transform: translateY(-2px);
  }
}

// ===== 响应式 =====
@media (max-width: 1024px) {
  .services-grid { grid-template-columns: repeat(2, 1fr); }
  .showcase-grid { grid-template-columns: repeat(3, 1fr); }
  .process-steps { grid-template-columns: repeat(2, 1fr); gap: 32px; }
  .product-hero-title { font-size: 40px; }
  .detail-container { grid-template-columns: 1fr; max-height: 90vh; }
  .detail-image-wrap { min-height: 250px; max-height: 40vh; }
}

@media (max-width: 768px) {
  .services-grid { grid-template-columns: 1fr; }
  .showcase-grid { grid-template-columns: repeat(2, 1fr); }
  .process-steps { grid-template-columns: 1fr; gap: 24px; }
  .product-hero-title { font-size: 32px; }
  .hero-stats-row { gap: 20px; }
  .hero-stat .stat-num { font-size: 24px; }
  .cta-actions { flex-direction: column; align-items: center; }
  .btn-primary, .btn-outline {
    width: auto !important;
    justify-content: center;
    padding: 14px 36px !important;
    font-size: 15px !important;
  }
  .detail-container { width: 95%; max-height: 92vh; }
  .detail-info { padding: 24px 20px; }
  .detail-title { font-size: 20px; }
  .detail-prev, .detail-next { width: 40px; height: 40px; }
  .detail-prev { left: 12px; }
  .detail-next { right: 12px; }
  .detail-close { top: 12px; right: 12px; width: 36px; height: 36px; }
}

</style>
